/**
 * Ticket Z1: Beschriftungen für die Mandatsfelder am Kunden.
 * Wird von Kundenformular und Kundenliste gemeinsam genutzt.
 *
 * Wichtig: Diese Felder haben KEINE Wirkung auf die Cockpit-Sichtbarkeit.
 * Die Sichtbarkeit steuert weiterhin ausschließlich `clients.category` (Ticket K9).
 */

import type { Database } from "@/integrations/supabase/types";

export type MandateType = Database["public"]["Enums"]["mandate_type"];
export type ElectionOutcome = Database["public"]["Enums"]["election_outcome"];

export const MANDATE_TYPES: MandateType[] = [
  "buergermeister",
  "oberbuergermeister",
  "landrat",
  "direktkandidat",
  "partei_gliederung",
  "verband",
  "kommune",
  "personalratsliste",
  "sonstiges",
];

export const MANDATE_TYPE_LABELS: Record<MandateType, string> = {
  buergermeister: "Bürgermeister",
  oberbuergermeister: "Oberbürgermeister",
  landrat: "Landrat",
  direktkandidat: "Direktkandidat",
  partei_gliederung: "Partei oder Gliederung",
  verband: "Verband oder Organisation",
  kommune: "Kommune oder Verwaltung",
  personalratsliste: "Personalratsliste",
  sonstiges: "Sonstiges",
};

export const ELECTION_OUTCOMES: ElectionOutcome[] = ["offen", "gewonnen", "verloren"];

export const ELECTION_OUTCOME_LABELS: Record<ElectionOutcome, string> = {
  offen: "offen",
  gewonnen: "gewonnen",
  verloren: "verloren",
};

export const TERM_START_HELP =
  "Optional. Wird das Datum gepflegt, rechnen spätere Module und Mailstrecken taggenau statt relativ zum Wahltag.";

export function mandateTypeLabel(value: MandateType | null | undefined): string {
  return value ? MANDATE_TYPE_LABELS[value] : "—";
}

export function electionOutcomeLabel(value: ElectionOutcome | null | undefined): string {
  return value ? ELECTION_OUTCOME_LABELS[value] : "—";
}

/** ISO-Datum (YYYY-MM-DD) deutsch formatiert; leer bleibt „—". */
export function formatDateDe(value: string | null | undefined): string {
  if (!value) return "—";
  const [y, m, d] = value.slice(0, 10).split("-");
  if (!y || !m || !d) return value;
  return `${d}.${m}.${y}`;
}
